<template>
    <div class="custom-time-picker">
        <input
            type="text"
            :value="formattedTime"
            @click="toggleDropdown"
            readonly
            class="time-input"
            aria-label="Time picker input"
        />
        <div v-if="isOpen" class="time-picker-dropdown" role="dialog" aria-label="Time selection dropdown">
            <div class="time-selector">
                <div class="hour-minute-selector">
                    <div class="selector">
                        <button type="button" @click="incrementHour" class="arrow up" aria-label="Increase hour">&#9650;</button>
                        <div class="value" aria-live="polite">{{ hour }}</div>
                        <button type="button" @click="decrementHour" class="arrow down" aria-label="Decrease hour">&#9660;</button>
                    </div>
                    <span class="colon">:</span>
                    <div class="selector">
                        <button type="button" @click="incrementMinute" class="arrow up" aria-label="Increase minute">&#9650;</button>
                        <div class="value" aria-live="polite">{{ minute }}</div>
                        <button type="button" @click="decrementMinute" class="arrow down" aria-label="Decrease minute">&#9660;</button>
                    </div>
                </div>
                <div class="period-selector">
                    <button
                        type="button"
                        :class="{ active: period === 'AM' }"
                        @click="setPeriod('AM')"
                        aria-label="Select AM"
                    >
                        AM
                    </button>
                    <button
                        type="button"
                        :class="{ active: period === 'PM' }"
                        @click="setPeriod('PM')"
                        aria-label="Select PM"
                    >
                        PM
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: false,
            default: '12:00 AM'
        }
    },
    data() {
        return {
            isOpen: false,
            hour: 11,
            minute: 23,
            period: 'AM'
        };
    },
    computed: {
        formattedTime() {
            return `${this.hour.toString().padStart(2, '0')}:${this.minute.toString().padStart(2, '0')} ${this.period}`;
        }
    },
    watch: {
        value(newValue) {
            if (newValue && newValue.includes(' ')) {
                const [time, period] = newValue.split(' ');
                const [hour, minute] = time.split(':');
                this.hour = parseInt(hour, 10) || 12;
                this.minute = parseInt(minute, 10) || 0;
                this.period = period || 'AM';
            } else {
                this.hour = 12;
                this.minute = 0;
                this.period = 'AM';
            }
        }
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        incrementHour() {
            this.hour = (this.hour % 12) + 1;
            this.updateValue();
        },
        decrementHour() {
            this.hour = this.hour === 1 ? 12 : this.hour - 1;
            this.updateValue();
        },
        incrementMinute() {
            this.minute = (this.minute + 1) % 60;
            this.updateValue();
        },
        decrementMinute() {
            this.minute = this.minute === 0 ? 59 : this.minute - 1;
            this.updateValue();
        },
        setPeriod(period) {
            this.period = period;
            this.updateValue();
        },
        updateValue() {
            this.$emit('input', this.formattedTime);
        }
    },
    mounted() {
        if (this.value && this.value.includes(' ')) {
            const [time, period] = this.value.split(' ');
            const [hour, minute] = time.split(':');
            this.hour = parseInt(hour, 10) || 12;
            this.minute = parseInt(minute, 10) || 0;
            this.period = period || 'AM';
        } else {
            this.hour = 12;
            this.minute = 0;
            this.period = 'AM';
        }
    }
};
</script>

<style scoped>
.custom-time-picker {
    position: relative;
    width: 100%;
}

.time-input {
    width: 100%;
    padding: 10px;
    border: 1px solid #C9C9C9;
    border-radius: 4px;
    background-color: #F0F0F0;
    text-align: center;
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
}

.time-picker-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #FFFFFF;
    border: 1px solid #C9C9C9;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    z-index: 10000;
    padding: 10px;
}

.time-selector {
    display: flex;
    align-items: center;
}

.hour-minute-selector {
    display: flex;
    align-items: center;
}

.selector {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.value {
    font-size: 24px;
    margin: 5px 0;
    background-color: #F0F0F0;
    padding: 5px 10px;
    border-radius: 4px;
    font-family: 'Poppins', sans-serif;
}

.arrow {
    background: none;
    border: none;
    color: #673AB7;
    font-size: 18px;
    cursor: pointer;
    padding: 0;
}

.colon {
    font-size: 24px;
    margin: 0 10px;
    font-family: 'Poppins', sans-serif;
}

.period-selector {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
}

.period-selector button {
    padding: 5px 10px;
    border: none;
    background-color: #F0F0F0;
    color: #333;
    cursor: pointer;
    border-radius: 4px;
    margin: 2px 0;
    font-family: 'Poppins', sans-serif;
}

.period-selector button.active {
    background-color: #673AB7;
    color: #FFFFFF;
}
</style>
